import SuperRepository from '../superRepository'

export default new (class smsRepository extends SuperRepository {
  baseUri() {
    return 'sms'
  }

  getStatus = async id => this.httpClient().get(`${this.baseUri()}/${id}/status`)
})()
